'use client'

import * as m from 'motion/react-m'
import { useTransform, useScroll } from 'motion/react'
import { Motion } from '@/lib/motion/lazy-motion'

import Container from '@/components/structure/Container'
import Breadcrumb from '@/components/ui/Breadcrumb'
import Timestamp from '@/components/ui/Timestamp'
import Statistics, { type Statistic } from '@/components/ui/Statistics'
import FTC from '@/components/widgets/ftc/FTC'

import type { App } from '@/payload-types'
import { LinkProps } from '@/types/app'
import { cn } from '@/lib/utils'

type MetaProps = {
  modifiedTimestamp?: string
  publishedTimestamp?: string
  parent?: LinkProps
  current?: string
  selectedLabel?: string
  stats?: Statistic[]
  ftc?: boolean
  apps?: Pick<App, 'name' | 'slug'>[]
  className?: string
}

export default function Meta({
  modifiedTimestamp,
  publishedTimestamp,
  parent,
  current,
  selectedLabel,
  stats,
  ftc,
  apps,
  className,
}: MetaProps) {
  const { scrollY } = useScroll()
  const centerOnMobile = !ftc && !stats
  const opacity = useTransform(scrollY, [0, 50], [1, 0])

  return (
    <Motion>
      <m.div
        style={{ opacity: opacity }}
        className={cn('absolute top-20 z-40 w-full md:top-28', className)}
      >
        <Container className="flex items-center justify-between gap-4 sm:h-8">
          <Breadcrumb
            theme="dark"
            parent={parent}
            current={current}
            selectedLabel={selectedLabel}
            apps={apps}
            center={centerOnMobile}
          />

          <div className={cn('gap-3', centerOnMobile ? 'hidden sm:flex' : 'flex')}>
            {ftc && <FTC position="inline" />}
            {(modifiedTimestamp || publishedTimestamp) && (
              <Timestamp
                modified={modifiedTimestamp}
                published={publishedTimestamp}
                lead="Updated"
                className="hidden sm:flex"
              />
            )}
            {stats && <Statistics stats={stats} />}
          </div>
        </Container>
      </m.div>
    </Motion>
  )
}
